

export const Contact = () => {
    return (
        <div className="contact-page">
    

            <div className="title">
                <p>CONTACT ME</p>
            </div>

            <div className="contact-container">
                <div className="contact-info">
                    <p><strong>Email 1:</strong> <a href="mailto:adithyabharadwaj15@gmail.com">adithyabharadwaj15@gmail.com</a></p>
                    <p><strong>Email 2:</strong> <a href="mailto:cs22b1040@iiitdm.ac.in">cs22b1040@iiitdm.ac.in</a></p>
                    <p><strong>Phone:</strong> +91 7795973505</p>
                    <p><strong>LinkedIn:</strong> <a href="https://www.linkedin.com/in/adithya-bharadwaj-5701712a6/" target="_blank" rel="noopener noreferrer">Connect with me on LinkedIn</a></p>
                </div>
            </div>
        </div>
    );
};
